import React, { useState, useEffect, useRef } from "react";
import styles from "./treatmentDropDownItem.module.scss";
import tick from "../../../static/images/check-mark.png";
export const TreatmentDropDownItem = ({
  dressing,
  index,
  id = "",
  name = "",
  label = "",
  listOptions,
  required = false,
  classes,
  getData,
  defaultValue = [],
  dropValue,
  setGetValueDrop,
}) => {
  const [viewDropDown, setDropDown] = useState(false);
  const [selectedValues, setSelectedValues] = useState(Array.isArray(defaultValue) ? defaultValue : []);
  const dropDownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropDownRef.current && !dropDownRef.current.contains(e.target)) {
        setDropDown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (dressing === "secondary" && dropValue === true) {
      setSelectedValues([]);
    } else {
      setSelectedValues(defaultValue);
    }
  }, [dropValue, dressing]);

  /* Function to toggle drop assessment*/
  const handleDropDown = (e) => {
    setDropDown(!viewDropDown);
  };

  const handleDropChangeTreatMent = (option) => {
    const value = option?.materialNumber;
    const isSelected = selectedValues.some((item) => item.value === value);
  
    let updated;
    if (isSelected) {
      updated = selectedValues.filter((item) => item.value !== value);
    } else {
      updated = [
        ...selectedValues,
        { value: value, isRecommended: option.isRecommended || 0 },
      ];
    }
  
    setSelectedValues(updated);
    getData(name, updated);
  
    if (dressing === "secondary" && dropValue === true) {
      setGetValueDrop(false);
    }
  
    setDropDown(false);
  };

  return (
    <div className={`${classes ? classes.column : ""} mouse-Down`} key={index}>
      {label && (
        <label
          htmlFor={id}
          className={`${classes.labelClassName} 
                    ${styles.text_field_label}`}
        >
          {`${label}:`}
          {required ? <span className={styles.astrick}>&#42;</span> : ""}
        </label>
      )}
      <div className={`${classes ? classes.inputColumn : ""}`}>
        <div className={`dropdown ${styles.risk_select_box}`}>
          <div
            className={`btn btn-secondary dropdown-toggle testdropdown ${styles.drop_arrow} ${styles.dropdown_toggle} `}
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            onClick={handleDropDown}
            ref={dropDownRef}
            id={id + "dyn"}
            data-testid="treatmentDropDown"
          >
            {selectedValues?.length === 0 ? (
              "Select"
            ) : (
              <>
                {selectedValues.map((val) => {
                  const getVal = listOptions.find((option) => option.materialNumber === val?.value);
                  if (!getVal) return null;

                  return (
                    <div key={val?.value} className={styles.selected_item_preview}>
                      <div className={`${styles.cat}`}>{getVal?.productFamilyDesc || "Select"}</div>

                      <div className={`${styles.material_description}`}>
                        <div>{getVal?.materialDescription || ""}</div>
                        {getVal?.materialDescription && (
                          <div className={`${styles.tick_div} ml-2`}>
                            <img src={tick} alt="tick" />
                          </div>
                        )}
                      </div>

                      {dressing !== "secondary" && val?.isRecommended === 1 && <div className={styles.recommended}>Recommended</div>}

                      <div className={`${styles.material_code}`}>{getVal?.materialCode}</div>
                    </div>
                  );
                })}
              </>
            )}
          </div>
          {viewDropDown && (
            <div className={`dropdown-menu show ${styles.risk_drop_down}`} aria-labelledby={id} ref={dropDownRef}>
              <>
                <div className={`dropdown-item  ${styles.risk_item_wrap}`} id={`handle_change`} onClick={(e) => handleDropChangeTreatMent("")}>
                  <div className={`${styles.cat}`}>Select</div>
                </div>
              </>
              {listOptions &&
                listOptions.length > 0 &&
                listOptions.map((optionValues, ind) => {
                  return (
                    <div
                      className={`dropdown-item  ${styles.risk_item_wrap} ${
                        selectedValues.some((item) => item.value === optionValues.materialNumber) ? styles.risk_item_wrap_selected : ""
                      }`}
                      id={`handle_change${ind}`}
                      onClick={(e) => handleDropChangeTreatMent(optionValues)}
                      key={ind}
                    >
                      <div className={`${styles.cat}`}>{optionValues.productFamilyDesc ? optionValues.productFamilyDesc : ""}</div>
                      <div className={`${styles.material_description}`}>
                        <div>{optionValues.materialDescription ? optionValues.materialDescription : ""}</div>
                        {selectedValues.some((item) => item.value === optionValues.materialNumber) && (
                          <div className={`${styles.tick_div} ml-2`}>
                            <img src={tick} alt="tick" />
                          </div>
                        )}
                      </div>
                      {dressing !== "secondary" && optionValues?.isRecommended === 1 ? (
                        <div className={`${styles.recommended}`}>Recommended</div>
                      ) : (
                        ""
                      )}
                      <div className={`${styles.material_code}`}>{optionValues?.materialCode}</div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
